import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import Icon from '../../../../components/Icon';
import PriceChecker from '../../../../components/PriceChecker';
import { HOTEL_SEARCHER_REPEAT_DELAY } from '../../constants';

const StyledIcon = styled(Icon)`
  circle {
    fill: ${(props) => props.theme.colors.yellowBase};
  }
`;

const StyledPriceChecker = styled(PriceChecker)`
  display: inline-flex;
  align-items: center;

  ${StyledIcon} {
    margin: 0 4px;
    flex-grow: 1;
  }

  ${PriceChecker.StyledDuration} {
    min-width: 38px;
  }
`;

const SearcherTimer = ({ lastUpdated, isHotelOnly }) => {
  const { t } = useTranslation();
  if (!lastUpdated) return null;
  return (
    <StyledPriceChecker
      lastUpdated={lastUpdated}
      timeout={HOTEL_SEARCHER_REPEAT_DELAY}
      text={t('hotel.searcherTimer', {
        context: isHotelOnly ? 'hotel' : 'package',
      })}
      fetchingText={t('hotel.searcherTimer', { context: 'update' })}
      icon={<StyledIcon type="clock" />}
    />
  );
};

SearcherTimer.defaultProps = {
  lastUpdated: null,
};

SearcherTimer.propTypes = {
  lastUpdated: PropTypes.number,
};

export default SearcherTimer;
